import reducer from 'state/direct-order/insurance/reducer';
import actions from 'state/direct-order/insurance/actionCreators';
import selectors from 'state/direct-order/insurance/selectors';
import effects from 'state/direct-order/insurance/effects';

export { actions, selectors, effects };
export default reducer;
